export default __webpack_public_path__ + "static/media/reddit-circle.77979885.svg";